<template>
    <div class="row">
        <div class="col-md-12">
            <div class="box">
                <div class="box-header"><h2>Call Verification <span class="float-right font-weight-light"><strong>Agent:</strong> {{ agent_name }}</span></h2>
                    <small></small>
                </div>
                <div class="box-divider m-0"></div>
                <div class="box-body">
                    <div id="call-check">

                        <div id="call_start" class="d-flex align-items-center" v-if="!active_call && !active_service">
                            <div class="call-buttons">
                                <h3 class="mb-4">Click to begin call verification...</h3>

                                <div class="call-start-button mx-2" v-for="service in agent_sites" style="width:150px; border:1px solid #ddd; background: #fff; display: inline-block; text-align: left" @click="start_call(service, '<strong>' + service.client.name + '</strong><br> ' + service.name, service.client.dpa_req, service.client.id)">
                                    <div style="height: 150px; background-color: #fff;width: 100%; border-bottom: 1px solid #ddd;" v-bind:style="{ backgroundImage: 'url(/images/client_logos/client-' + service.client.id + '.png)'}"> </div>
                                    <div style="padding: 10px; min-height: 100px;">
                                        <h5 class="font-weight-bold mt-2">{{ service.client.product }}</h5>
                                        <h6 style="font-size: 0.75em;">{{ service.name }}</h6>
                                        <div class="btn btn-primary d-block mt-3" style="min-width: 1px">Start Call</div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row" v-if="form_title">
                            <div class="col-md-3">
                                <div id="call-info">

                                    <div class="mb-3" style="height: 150px; background-color: #fff;width: 100%; background-repeat: no-repeat; background-position: center; border: 1px solid #ddd;" v-bind:style="{ backgroundImage: 'url(/images/client_logos/client-' + active_client + '.png)'}"> </div>

                                    <h4 class="mb-3" v-html="form_title"></h4>

                                    <div class="box-divider m-0"></div>
                                    <div v-if="customer && verified_field === 'phone'" class="my-3">
                                        <p><strong>Verified Number:</strong><br>{{ phone }}</p>
                                    </div>
                                    <div v-if="customer && verified_field === 'email'" class="my-3">
                                        <p class="small"><strong>Verified Email:</strong><br>{{ email }}</p>
                                    </div>

                                    <div v-if="customer" class="my-3">
                                        <ul class="list-unstyled">
                                            <li v-if="customer.name"><i class="fa fa-check text-secondary" v-bind:class="{ 'text-success': verified_name == 1, 'text-danger': verified_name == 0, 'text-muted': verified_name == null }"></i> Customer Name</li>
                                            <li v-if="customer.company_name"><i class="fa fa-check text-secondary" v-bind:class="{ 'text-success': verified_company == 1, 'text-danger': verified_company == 0, 'text-muted': verified_company == null }"></i> Company Name</li>
                                            <li v-if="customer.address_line_1"><i class="fa fa-check text-secondary" v-bind:class="{ 'text-success': verified_address == 1, 'text-danger': verified_address == 0, 'text-muted': verified_address == null }"></i> Address</li>
                                            <li v-if="customer.postal_code"><i class="fa fa-check text-secondary" v-bind:class="{ 'text-success': verified_postcode == 1, 'text-danger': verified_postcode == 0, 'text-muted': verified_postcode == null }"></i> Postcode</li>
                                        </ul>
                                    </div>

                                    <div v-if="customer" class="my-3 mt-4">
                                        <div v-if="caller_validated == null" class="btn btn-secondary d-block">PENDING</div>
                                        <div v-if="caller_validated === 1" class="btn btn-success d-block">PASSED</div>
                                        <div v-if="caller_validated === 0" class="btn btn-danger d-block">FAILED</div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-9">

                                <div v-if="valid == true" class="" role="alert">
                                    <h3 class="" mb-3>{{ success_message }}</h3>
                                </div>

                                <div v-if="valid == false" class="alert alert-danger valid-fail" role="alert">
                                    {{ error_message }}
                                </div>

                                <form autocomplete='off' id="verification-form" v-if="active_service && !customer">
                                    <div class="form-group">
                                        <label for="mobile-number">Mobile Phone Number</label>
                                        <div class="input-group mb-2">
                                            <input class="form-control" v-model="phone" type="text" id="mobile-number" name="mobile-number"
                                                   :readonly="customer">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="mobile-number">Email Address</label>
                                        <div class="input-group mb-2">
                                            <input class="form-control" v-model="email" type="email" id="email" name="email"
                                                   :readonly="customer">
                                        </div>
                                    </div>
                                </form>

                                <div class="dpa-fields pt-3" v-if="customer && active_service">

                                    <div class="form-row" v-if="customer && customer.name">
                                        <div class="col-3">
                                            <label>Customer Name</label>
                                        </div>
                                        <div class="col-5">
                                            {{ customer.name }}
                                        </div>
                                        <div class="col text-right">
                                            <div class="verified">
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-name-pass" class="form-check-input validation" type="radio"
                                                           name="verified-name"
                                                           value="1" v-model="verified_name" :disabled="verified_name !== null">
                                                    <label class="form-check-label" for="verified-name-pass">Pass</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-name-fail" class="form-check-input validation" type="radio"
                                                           name="verified-name"
                                                           value="0" v-model="verified_name" :disabled="verified_name !== null">
                                                    <label class="form-check-label" for="verified-name-fail">Fail</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row" v-if="customer && customer.company_name">
                                        <div class="col-3">
                                            <label>Company Name</label>
                                        </div>
                                        <div class="col-5">
                                            {{ customer.company_name }}
                                        </div>
                                        <div class="col text-right">
                                            <div class="verified">
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-company-pass" class="form-check-input validation" type="radio"
                                                           name="verified-company"
                                                           value="1" v-model="verified_company" :disabled="verified_company !== null">
                                                    <label class="form-check-label" for="verified-company-pass">Pass</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-company-fail" class="form-check-input validation" type="radio"
                                                           name="verified-company"
                                                           value="0" v-model="verified_company" :disabled="verified_company !== null">
                                                    <label class="form-check-label" for="verified-company-fail">Fail</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row" v-if="customer && customer.address_line_1">
                                        <div class="col-3">
                                            <label>First Line Of Address</label>
                                        </div>
                                        <div class="col-5">
                                            {{ customer.address_line_1}}
                                        </div>
                                        <div class="col text-right">
                                            <div class="verified">
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-address-pass" class="form-check-input validation" type="radio"
                                                           name="verified-address"
                                                           value="1" v-model="verified_address" :disabled="verified_address !== null">
                                                    <label class="form-check-label" for="verified-address-pass">Pass</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-address-fail" class="form-check-input validation" type="radio"
                                                           name="verified-address"
                                                           value="0" v-model="verified_address" :disabled="verified_address !== null">
                                                    <label class="form-check-label" for="verified-address-fail">Fail</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row" v-if="customer && customer.postal_code">
                                        <div class="col-3">
                                            <label>Postcode</label>
                                        </div>
                                        <div class="col-5">
                                            {{ customer.postal_code }}
                                        </div>
                                        <div class="col text-right">
                                            <div class="verified">
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-postcode-pass" class="form-check-input validation" type="radio"
                                                           name="verified-postcode"
                                                           value="1" v-model="verified_postcode" :disabled="verified_postcode !== null">
                                                    <label class="form-check-label" for="verified-postcode-pass">Pass</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input id="verified-postcode-fail" class="form-check-input validation" type="radio"
                                                           name="verified-postcode"
                                                           value="0" v-model="verified_postcode" :disabled="verified_postcode !== null">
                                                    <label class="form-check-label" for="verified-postcode-fail">Fail</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <textarea class="form-control mt-3" v-model="call_notes" placeholder="Call Notes" rows="6"></textarea>

                                </div><!-- end dpa fields -->
                                <span class="float-left mt-4" v-if="active_call && active_service && (caller_validated === 1 || caller_validated === 0)">Click 'End Call' to save call notes and record call stats.</span>
                                <div class="align-content-center d-inline-flex">
                                    <button class="btn btn-primary mt-3 mr-2" v-if="!customer && !working" type="button" v-on:click="search('phone')">Verify Number</button>
                                    <span v-if="!customer && !working" class="mr-3 ml-2 mt-4">OR</span>
                                    <button class="btn btn-primary mt-3 mr-2" v-if="!customer && !working" type="button" v-on:click="search('email')">Verify Email</button>
                                </div>
                                <button class="btn btn-primary mt-3 mr-2" v-if="!customer && working" type="button">Checking <i class="ml-2 fa fa-spinner fa-spin"></i></button>
                                <button class="btn btn-danger mt-3 float-right" @click="end_call" v-if="active_call && active_service && !working">End Call</button>
                                <button class="btn btn-danger mt-3 float-right" v-if="active_call && active_service && working && customer">Saving <i class="ml-2 fa fa-spinner fa-spin"></i></button>
                                <button class="btn btn-danger mt-3 float-right" @click="cancel" v-if="!active_call && active_service">Cancel</button>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    $(document).on("keydown", "#call-check form", function (event) {
        return event.key != "Enter";
    });

    export default {
        name: "agent-call-check",
        props: {
            agent_id: String,
            agent_sites: Array,
            agent_name: String,
        },

        data() {
            return {
                working: false,
                valid: null,
                error_message: "",
                success_message: "Caller details found, please confirm identity.",
                phone: "",
                email: "",
                customer: null,
                active_call: false,
                service: null,
                active_service: null,
                api_config: null,
                active_client: 1,
                form_title: "",
                call_id: null,
                call_start: null,
                attempt: 1,
                verified_field: null,
                verified_name: null,
                verified_company: null,
                verified_address: null,
                verified_postcode: null,
                caller_validated: null,
                call_notes: "",
                dpa_score: 2,
                client_code: null
            }
        },
        mounted() {
        },
        methods: {
            start_call: function (service, form_title, dpa_req, client) {
                this.service = service;
                this.call_start = new Date().getTime();
                this.active_service = service.id;
                this.form_title = form_title;
                this.dpa_score = dpa_req;
                this.active_client = client;

                this.api_config = {
                    headers: {
                        'Authorization' : 'Bearer ' + this.service.client.api_token,
                        'Accept' : 'application/json',
                        'Content-Type' : 'application/json'
                    }
                }
            },
            search: function (field = 'phone') {
                let value_to_check;
                this.working = true;
                this.active_call = true;

                switch(field) {
                    case 'email':
                        if (this.email.length < 3) {
                            this.valid = false;
                            this.error_message = "Please enter a valid email address.";
                            this.working = false;
                            return false;
                        }
                        value_to_check = this.email;
                        break;
                    default:
                        let mobile = this.phone.replace(/ /g, '');
                        if (mobile.length < 11) {
                            this.valid = false;
                            this.error_message = "The phone number must be at least 11 characters long.";
                            this.working = false;
                            return false;
                        }
                        value_to_check = mobile;
                }

                axios.post(this.service.client.api + '/agent/check', {
                        value: value_to_check,
                        field: field,
                        call_start: this.call_start,
                        agent_id: this.agent_id,
                        agent_name: this.agent_name,
                        attempt: this.attempt,
                        call_id: this.call_id,
                        site_id: this.service.site_id
                    }, this.api_config)
                    .then(response => {
                        this.working = false;
                        this.call_id = response.data.call.id;
                        if(response.data.client_code) {
                            this.client_code = response.data.client_code;
                        }
                        if (response.data.customer) {
                            if (response.data.call.verified_subscription) {
                                this.verified_field = field;
                                this.customer = response.data.customer;
                                this.valid = true;
                            } else {
                                this.valid = false;
                                this.error_message = "Customer not Eligible for this service, lookup has been logged.";
                                this.attempt = this.attempt + 1;
                                return false;
                            }
                        } else {
                            this.valid = false;
                            this.error_message = "Customer not found, lookup has been logged.";
                            this.attempt = this.attempt + 1;
                            return false;
                        }
                    });

            },
            getMaxDpaScore: function() {

                if(!this.customer) {
                    return this.dpa_score;
                }

                let score = 0;
                if(this.customer.name) {
                    score++;
                }
                if(this.customer.company_name) {
                    score++;
                }
                if(this.customer.address_line_1) {
                    score++;
                }
                if(this.customer.postal_code) {
                    score++;
                }

                if(score < this.dpa_score) {
                    return score;
                }

                return this.dpa_score;
            },
            validate: function () {
                let verified_count = 0;
                let failed_count = 0;

                if (this.verified_name === '1') {
                    verified_count++;
                }
                if (this.verified_company === '1') {
                    verified_count++;
                }
                if (this.verified_address === '1') {
                    verified_count++;
                }
                if (this.verified_postcode === '1') {
                    verified_count++;
                }
                if (this.verified_name === '0') {
                    failed_count++;
                }
                if (this.verified_company === '0') {
                    failed_count++;
                }
                if (this.verified_address === '0') {
                    failed_count++;
                }
                if (this.verified_postcode === '0') {
                    failed_count++;
                }

                if (verified_count >= this.getMaxDpaScore()) {
                    this.caller_validated = 1;
                    this.success_message = "Caller details verified, call log updated.";
                    this.send_validation();
                } else {
                    if ((this.getMaxDpaScore() - failed_count) < this.getMaxDpaScore()) {
                        this.caller_validated = 0;
                        this.success_message = "Caller details not verified, call log updated.";
                        this.send_validation();
                    }
                }
            },
            send_validation: function () {
                axios
                    .post(this.service.client.api + '/agent/validate', {
                        call_id: this.call_id,
                        client_code: this.client_code,
                        verified_name: this.verified_name,
                        verified_company: this.verified_company,
                        verified_address: this.verified_address,
                        verified_postcode: this.verified_postcode,
                        caller_validated: this.caller_validated
                    }, this.api_config)
                    .then(response => {
                    });
            },
            end_call: function () {
                this.working = true;
                axios
                    .post(this.service.client.api + '/agent/end', {
                        call_id: this.call_id,
                        client_code: this.client_code,
                        call_end: new Date().getTime(),
                        call_notes: this.call_notes
                    },this.api_config)
                    .then(response => {
                        this.cancel();
                        this.working = false;
                    });
            },
            cancel: function () {
                this.active_call = false;
                this.customer = null;
                this.client_code = null;
                this.call_id = null;
                this.phone = null;
                this.attempt = 1;
                this.valid = null;
                this.form_title = "";
                this.caller_validated = 0;
                this.service = null;
                this.active_service = null;
                this.verified_name = null;
                this.verified_company = null;
                this.verified_address = null;
                this.verified_postcode = null;
                this.caller_validated = null;
                this.call_notes = "";
                this.call_start = null;
                this.success_message = "Caller details found, please confirm identity.";
                this.phone = "";
                this.dpa_req = 2;
                this.email = "";
            }
        },
        watch: {
            verified_name: function () {
                this.validate();
            },
            verified_company: function () {
                this.validate();
            },
            verified_address: function () {
                this.validate();
            },
            verified_postcode: function () {
                this.validate();
            }
        }
    }
</script>
